import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent, EventName } from 'shared/lib/eventTracking';
import EcosystemVisual from './EcosystemVisual';


const CoralEcosystem: React.FC = () => {
  return (
    <div className="bg-white bg-opacity-100 shadow-lg rounded-xl p-6 m-3 max-w-4xl mx-auto">
      <div className="flex flex-col items-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 items-center w-full">
          <div className="text-center sm:text-left">
            <h2 className="font-syne text-2xl sm:text-2xl lg:text-3xl xl:text-4xl font-semibold text-gray-800 mb-2 sm:mb-4">
              The Coral Ecosystem
            </h2>
            <p className="text-base sm:text-lg text-gray-600">
              Back your artists.<br />Find your people.
            </p>
          </div>
          <div className="w-full aspect-square flex items-center justify-center">
            <EcosystemVisual width={280} height={200} />
          </div>
        </div>
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-400">
            Live visualisation of the coral ecosystem.
          </p>
          <Link
            to="/trust#trust-financials"
            onClick={() => trackEvent(EventName.VIEW_ALL_CONTRIBUTIONS_INTERACTION, {})}
            className="mt-2 text-xs text-coral-pink hover:underline focus:outline-none"
          >
            Download all our data
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CoralEcosystem;
